import { Component, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';
//PerOptionConfigurationComponent

@Component({
    selector: 'per-option-configuration',
    templateUrl: './per-option-configuration.component.html',
    styleUrls: ['./per-option-configuration.component.scss'],
    standalone: false
})
export class PerOptionConfigurationComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);
  }

  onSubmit() {
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
